export { GM } from './gm';
// 包装的上层 wheel 事件
export { Wheel } from './event';
//# sourceMappingURL=index.js.map